import { Link } from 'react-router-dom';
import ProductActionButton from './ProductActionButton';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  return (
  <div className="product-card" id={"goodsView"+product.goods_seq}>
    <Link className="product-detail" to={`/store/goods/${product.goods_seq}`}>
      <div className="product-thumb">
      {product.discount_price != null && (
          <span className="discount-badge">{Math.round(((product.price - product.discount_price) / product.price) * 100)}%</span>
            )}
        <div className="image-container">
          <img 
            src={"https://cdn.cokeplay.cocacola.co.kr" + product.list1_image_url} 
            alt=""
            className="product-image"
            loading="lazy"
          />
        </div>
      </div>
      <div className="product-info">
        <div className="product-name">
          <span>{product.display_goods_name}</span>
        </div>
        <div className="product-price">
            <div className="current-price">
                
                {product.discount_price != null && (
                    <span className="discount-percent">{Math.round(((product.price - product.discount_price) / product.price) * 100)}%</span>
                )}
                <span className="price-amount">{product.discount_price ? product.discount_price.toLocaleString() : product.price.toLocaleString()}</span>
                <span>원</span>
            </div>
    
        {product.discount_price && (
            <div className="original-price">
                <span>{product.price.toLocaleString()} 원</span>
            </div>
        )}
      </div>
      </div>
    </Link>
    <ProductActionButton goods_seq={product.goods_seq} bottom="140px" right="5px"/>
  </div>)
};

export default ProductCard; 


